import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Props for the Progress component.
 */
interface ProgressProps extends React.ComponentProps<'div'> {
  /** The progress value from 0 to 100. */
  value?: number;
}

/**
 * A simple progress bar indicator that fills from left to right.
 */
function Progress({ className, value = 0, ...props }: ProgressProps) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div
      data-slot="progress"
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('relative h-2 w-full overflow-hidden rounded-full bg-secondary', className)}
      {...props}
    >
      <div
        className="h-full bg-primary transition-all"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}

export { Progress };
